import { EmailParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): EmailParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EMAIL_PRIMITIVE,
  value: null,
});
